import axios from 'axios';

import { snakeCase, camelCase, transform } from 'lodash';

import i18n from '@/i18n';

const t = i18n.global.t;

import { message } from 'ant-design-vue';

import { useUserStore } from '@/stores/user';

const applyTransform = (obj, func) => {
	return transform(obj, (result, value, key) => {
		result[func(key)] = value;
	}, {})
};

const toSnakeCase = obj => applyTransform(obj, snakeCase);
const toCamelCase = obj => applyTransform(obj, camelCase);


// private
const logError = error => {
	const errorMessage = error.response?.data?.detail;
	const outputMessage = (errorMessage == null) ? t('common.unknownError') : errorMessage;
	message.error(outputMessage + t('common.reloginError'));
};

// private
const getToken = (username, password, successHandler, errorHandler) => {
	const userStore = useUserStore()
	userStore.logout()
	axios.post('/token/login/', { username, password }).then(response => {
		userStore.login(response.data);
		successHandler();
	}).catch(errorHandler);
};

const logout = () => {
	axios.post('/token/logout/', useUserStore().token);
};

const createUserAndGetToken = (data, successHandler, errorHandler) => {
	axios.post('/users/', toSnakeCase(data)).then(response => {
		if (response.status == 201) {
			getToken(data.username, data.password, successHandler, errorHandler);
		}
	}).catch(errorHandler);
};

const activateAccount = (uid, token, successHandler, errorHandler) => {
	axios.post('/user/activate/', { uid, token }).then(extractData(successHandler)).catch(errorHandler);
}

const getActivationEmailCooldown = successHandler => {
	axios.get('/user/get_activation_email_cooldown/').then(extractData(successHandler)).catch(logError);
}

const resendActivationEmail = successHandler => {
	axios.post('/user/resend_activation_email/', {}).then(extractData(successHandler)).catch(logError);
}

// private
const extractData = (handler) => {
	const extractDataCore = response => handler(response.data);
	return extractDataCore;
}

const roverGetList = handler => {
	axios.get('/rover/get_list/').then(extractData(handler)).catch(logError);
};

const roverGetOne = (roverId, handler) => {
	axios.get('/rover/get_one/?rover_id=' + roverId).then(extractData(handler)).catch(logError);
};

const roverGetSettings = (handler) => {
	axios.get('/rover/get_settings/').then(extractData(handler)).catch(logError);
};

const roverAdd = (data, handler) => {
	axios.post('/rover/add/', {
		...data,
		user_id: data.uid,
	}).then(extractData(handler)).catch(logError);
};


const roverChangeStatus = (id, action, handler) => {
	axios.post('/rover/change_status/', { id, action }).then(extractData(handler)).catch(logError);
};


const roverUpdate = (data, handler) => {
	axios.post('/rover/update/', data).then(extractData(handler)).catch(logError);
};


const roverUpdatePassword = (data, handler) => {
	axios.post('/rover/update_password/', data).then(extractData(handler)).catch(logError);
};


const roverStatsGet = handler => {
	axios.get('/stats/rovers/uptime_get/').then(extractData(handler)).catch(logError);
};


const adminMainStatsGet = handler => {
	axios.get('/stats/admin/main/').then(extractData(handler)).catch(logError);
};


const changePassword = (oldPassword, password, successHandler, errorHandler) => {
	axios.post('/users/set_password/', {
		current_password: oldPassword,
		new_password: password,
	}).then(successHandler).catch(errorHandler);
};


const tariffGetList = handler => {
	axios.get('/finance/tariff/get_list/').then(extractData(handler)).catch(logError);
};


const tariffExtend = (addDays, roverIds, handler) => {
	axios.post('/finance/tariff/extend/', {
		add_days: addDays,
		rover_ids: roverIds,
	}).then(extractData(handler)).catch(logError);
};


const tariffChange = (tariffId, addDays, roverIds, handler) => {
	axios.post('/finance/tariff/change/', {
		tariff_id: tariffId,
		add_days: addDays,
		rover_ids: roverIds,
	}).then(extractData(handler)).catch(logError);
};


const paymentGetList = handler => {
	axios.get('/finance/payment/get_list/').then(extractData(handler)).catch(logError);
}


const paymentGetOne = (uuid, handler) => {
	axios.get('/finance/payment/get_one/?uuid=' + uuid).then(extractData(handler)).catch(logError);
}


export default {
	getToken,
	createUserAndGetToken,
	activateAccount,
	getActivationEmailCooldown,
	resendActivationEmail,
	logout,
	roverGetList,
	roverGetOne,
	roverGetSettings,
	roverAdd,
	roverChangeStatus,
	roverUpdate,
	roverUpdatePassword,
	roverStatsGet,
	adminMainStatsGet,
	changePassword,
	tariffGetList,
	tariffExtend,
	tariffChange,
	paymentGetList,
	paymentGetOne,
}
